

<div class="margin">
  <panel>
    <div *ngIf="system?.Components.length == 0"> {{"There is no components on this system, please make sure your undercarriage setup correctly " | translate | async}} </div>
    <div class="table-container" *ngIf="system?.Components.length > 0">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th></th>
            <th>{{'Component' | translate | async}}</th>
            <th>{{'Position' | translate | async}}</th>
            <th>{{'Worn(%)' | translate | async}}</th>
            <th>{{'Measurement' | translate | async}}</th>
            <th>{{'Tool' | translate | async}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of system?.Components">
            <td class="component-cell" *ngIf="!c.IsChild">
              <div class="component-photo-container">
                <img class="component-photo" [src]="sanitize(c.ComponentImage, true)" />
              </div>
            </td>
            <td *ngIf="c.IsChild" class="line-cell">
              <div class="line-vert{{getChildRowPosition(c.GeneralEqUnitId)}}"> </div>
              <div class="line-hor"></div>
            </td>
            <td>
              <span title="{{c.Name}}" *ngIf="!c.IsChild">{{c.Name | slice:0:30}} {{c.Name.length>30 ? '...' : ''}} </span>
              <span title="{{c.Name}}" *ngIf="c.IsChild">{{c.Name | slice:0:30}} {{c.Name.length>30 ? '...' : ''}}</span>
            </td>
            <td *ngIf="c.IsChild"></td>
            <td *ngIf="!c.IsChild"> {{showPosition(c.ActualPosition, c.CompartTypeId)}}</td>
            <td class="table__eval-cell">
              <span style="width: 80px;" [ngClass]="GetEvalColour(c, c.WornPercentage.toFixed(1))">
                  <div style="text-align: center !important; display: inline-block;">
      <!-- Eval tool -->
      <ng-container *ngIf="c.ToolId === toolType.Eval">
        {{ c.EvalCode }}
      </ng-container>

      <!-- Yes/No or Pass/Fail -->
      <ng-container *ngIf="c.ToolId === toolType.YESorNO || c.ToolId === toolType.PassorFail">
       {{'-'}}
      </ng-container>

      <!-- All others -->
      <ng-container *ngIf="c.ToolId !== toolType.Eval && c.ToolId !== toolType.YESorNO && c.ToolId !== toolType.PassorFail">
        {{ c.MeasurementReading === -1 ? '-' : (c.WornPercentage.toFixed(1) + '%') }}
      </ng-container>
    </div>
              </span>
            </td>
           <td>
            <ng-container *ngIf="c.ToolId == toolType.YESorNO">
              {{ 
                  c.MeasurementReading === -1 
                    ? 'U' 
                    : (c.MeasurementReading === 1 
                        ? ('Yes' | translate | async) 
                        : ('No' | translate | async)
                      ) 
                }}
            </ng-container>
            <ng-container *ngIf="c.ToolId == toolType.PassorFail">

              {{ 
                c.MeasurementReading === -1 
                  ? 'U' 
                  : (c.MeasurementReading === 1 ? ('Pass' | translate | async) : ('Fail' | translate | async)
                    ) 
              }}
                          
            </ng-container>
            <ng-container *ngIf="c.ToolId !== toolType.Eval && c.ToolId !== toolType.YESorNO && c.ToolId !== toolType.PassorFail">
              {{ c.MeasurementReading !== -1 ? (c.MeasurementReading + ' ' + (c.IsMeasuredInInches ? 'inches' : 'mm')) : '-' }}
            </ng-container>
          </td>
          <td>
                {{c.ToolName}}
          </td>
          </tr>
        </tbody>
      </table>
    </div>
  </panel>
</div>
